import { DayFlag, SelectionState, UI } from "../UI.js";
export function getClassNamesForModifiers(modifiers, classNames) {
  let modifiersClassNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const modifierClassNames = Object.entries(modifiers).filter(_ref => {
    let [, active] = _ref;
    return active === true;
  }).reduce((previousValue, _ref2) => {
    let [key] = _ref2;
    if (modifiersClassNames[key]) {
      previousValue.push(modifiersClassNames[key]);
    } else if (classNames[DayFlag[key]]) {
      previousValue.push(classNames[DayFlag[key]]);
    } else if (classNames[SelectionState[key]]) {
      previousValue.push(classNames[SelectionState[key]]);
    }
    return previousValue;
  }, [classNames[UI.Day]]);
  return modifierClassNames;
}